import styled from "styled-components";

export const ProductBoxContainer = styled.div`
    align-items: center;
    display: flex;
    flex-direction: column;
    gap: 24px; 
    height: 375px;
    justify-content: center;
    transition: 0.4s ease-in;
    width: 350px;
`